import { uploadFileDocument } from '../../../api'
import { UPLOAD_IMAGE_CROP_SHAPE } from '../../UploadImage'

import { MOCK_DELAY, UPLOAD_MODE } from './UploadImageUsage.constants'

function mockUploadSuccess({ dataUrl }) {
  return new Promise(resolve => {
    setTimeout(
      () => resolve({ id: 'mock-document-id', preview: dataUrl }),
      MOCK_DELAY
    )
  })
}

function mockUploadError() {
  return new Promise((resolve, reject) => {
    setTimeout(reject, MOCK_DELAY)
  })
}

export function getUpload(uploadMode) {
  if (uploadMode === UPLOAD_MODE.REAL) {
    return uploadFileDocument
  }

  return uploadMode === UPLOAD_MODE.ERROR ? mockUploadError : mockUploadSuccess
}

// Step-2 stand-in: logos and avatars both send a scalar id
export function buildEntityPayload({ cropShape, documentId }) {
  return cropShape === UPLOAD_IMAGE_CROP_SHAPE.RECTANGLE
    ? { logo: documentId }
    : { avatar: documentId }
}
